<div class="row" id="calenderRow">
    <div class="col-lg-12">
        <mat-card appearance="outlined" class="form-card" [formGroup]="calenderFilterForm">
            <mat-card-header>
                <mat-card-title-group>
                    <mat-card-title>Reservierungen nach Tagen</mat-card-title>
                </mat-card-title-group>
                <div fxFlex></div>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="full-width">
                    <mat-label>Event auswählen</mat-label>
                    <mat-select formControlName="event" (selectionChange)="changeEventForCalenderChart($event)">
                        <mat-option *ngFor="let sortOption of events" [value]="sortOption.value"
                            [disabled]="sortOption.state">
                            {{sortOption.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div id="calendar_basic" style="width: 100%;min-height: 300px;"></div>
                <div *ngIf="isCalenderChartEmpty" class="pieChartEmptyState">
                    Für diese Aktion sind noch keine Reservierungen vorhanden.
                </div>
                <div *ngIf="!finishedLoadingCalendeData" class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>